import { dishes as saucesDishes } from 'global/const/sauces';
import {
    allDishes as kidsDishes,
    SCHOOL_TAG,
} from '../../../../landings/promo-checkout/src/pages/kids/build-config';


// Map with dishes (and tags) which are hidden behind PromoMaxiBlock;
export const maxiBlockDishesParams = {
    sauces: {
        dishes: saucesDishes,
        tag: null,
    },
    kids: {
        dishes: kidsDishes,
        tag: SCHOOL_TAG,
    },
};

export const maxiKidsDishes = maxiBlockDishesParams.kids.dishes;
export const maxiSaucesDishes = maxiBlockDishesParams.sauces.dishes;

